module.exports = __webpack_public_path__ + "static/media/Cave Woman.002f2afd.jpg";